export const StatStyle = {
  parts: ['label', 'number'],
  // Styles for the base style
  baseStyle: {
    label: {
      color: 'text.subtle',
      lineHeight: 1,
      mb: 2,
    },
    number: {
      lineHeight: 1,
    },
  },
  // Styles for the size variations
  sizes: {
    md: {
      label: {
        fontSize: 'md',
      },
      number: {
        fontSize: 'md',
      },
    },
  },
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
}
